import React from "react";
import { Link } from "react-router-dom";

const CheckoutCancel = () => (
  <div className="settings-page">
    <div className="settings-section" style={{ textAlign: "center", padding: "40px 28px" }}>
      <div style={{ fontSize: 36, marginBottom: 12, color: "var(--color-dim)" }}>✕</div>
      <p className="settings-success__msg" style={{ color: "var(--color-dim)" }}>Payment cancelled</p>
      <p className="settings-success__sub" style={{ marginTop: 8, marginBottom: 24 }}>
        No charge was made. You can subscribe any time from your account settings.
      </p>
      <Link
        to="/usersettings"
        className="settings-btn settings-btn--outline"
        style={{ display: "inline-block", width: "auto", padding: "10px 32px" }}
      >
        Back to Account
      </Link>
    </div>
  </div>
);

export default CheckoutCancel;
